var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafepal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2631_30995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5 24C48.5 10.7452 37.7548 0 24.5 0C11.2452 0 0.5 10.7452 0.5 24C0.5 37.2548 11.2452 48 24.5 48C37.7548 48 48.5 37.2548 48.5 24Z",
    fill: "#4A21EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8441 10.5596C22.439 10.5596 22.0379 10.6393 21.6637 10.7943C21.2894 10.9493 20.9494 11.1765 20.6629 11.4629L11.5763 20.5498C11.4124 20.7133 11.2824 20.9076 11.1938 21.1216C11.1052 21.3355 11.0597 21.5648 11.0601 21.7964C11.0601 22.2476 11.2321 22.6985 11.5763 23.0427L17.5312 28.9976V18.4553C17.5312 17.6686 18.1638 17.0307 18.9505 17.0307H31.4687L37.9398 10.5596H22.8441ZM17.5314 30.9685H30.0445C30.4223 30.9684 30.7846 30.8183 31.0518 30.5511C31.3189 30.2839 31.4689 29.9216 31.4689 29.5438V19.0016L37.4238 24.9564C37.5877 25.1199 37.7177 25.3142 37.8063 25.5281C37.8949 25.742 37.9403 25.9713 37.9401 26.2028C37.9404 26.4343 37.8949 26.6636 37.8063 26.8775C37.7177 27.0913 37.5877 27.2856 37.4238 27.4491L28.3372 36.5362C27.7586 37.1146 26.9741 37.4395 26.1561 37.4396H11.0603L17.5314 30.9685Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2631_30995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafepal);
export default __webpack_public_path__ + "static/media/safepal.f00dea7a0ffe170e22b23f0871ba381d.svg";
export { ForwardRef as ReactComponent };